<!-- Ships Listing -->
<div class="card">
  <!-- Card Header -->
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <h3 class="fw-bold m-0">Ships Management</h3>
    </div>

    <!-- Card Toolbar -->
    <div class="card-toolbar">
      <!-- Filter Button -->
      <div class="d-flex justify-content-end me-3">
        <button type="button" class="btn btn-sm btn-dark fw-bold d-flex" [class.active]="showFiltersForm"
          (click)="toggleFilters()">
          <i class="ki-duotone ki-filter fs-6 text-muted me-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span>Filter</span>
        </button>
      </div>

      <!-- Add Ship Button -->
      <div class="d-flex justify-content-end">
        <button type="button" class="btn btn-sm btn-success d-flex" (click)="openAddShipModal()">
          <i class="ki-duotone ki-plus fs-6 me-1">
            <span class="path1"></span>
            <span class="path2"></span>
            <span class="path3"></span>
          </i>
          <span>Add Ship</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Filter Section -->
  <div class="card-body border-bottom py-4" *ngIf="showFiltersForm" [@slideInOut]>
    <div class="row g-4">
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Search Ships</label>
        <div class="d-flex align-items-center position-relative">
          <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-3">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <input type="text" class="form-control form-control-sm ps-10" placeholder="Search ships..."
            [(ngModel)]="searchTerm" (keyup.enter)="applyFilters()" />
        </div>
      </div>
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Date From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.date_from" />
      </div>
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Date To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.date_to" />
      </div>
    </div>

    <!-- Filter Actions -->
    <div class="row mt-4">
      <div class="col-12">
        <div class="d-flex justify-content-end gap-3">
          <button type="button" class="btn btn-sm btn-light" (click)="clearFilters()">
            <i class="ki-duotone ki-cross fs-4 me-1">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Clear Filters
          </button>
          <button type="button" class="btn btn-sm btn-primary" (click)="applyFilters()">
            <i class="ki-duotone ki-magnifier fs-4 me-1">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Apply Filters
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Card Body -->
  <div class="card-body py-4">
    <!-- Ships Table -->
    <div class="table-responsive">
      <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
        <thead>
          <tr class="fw-bold text-muted bg-light">
            <th class="min-w-150px">Ship Name</th>
            <th class="min-w-100px">Ship ID</th>
            <th class="min-w-100px">Company</th>
            <th class="min-w-100px">Voyage No</th>
            <th class="min-w-120px">Sailing Port</th>
            <th class="min-w-120px">Destination Port</th>
            <th class="min-w-120px">Destination Country</th>
            <th class="min-w-100px">Sailing Date</th>
            <th class="min-w-100px">Arrival Date</th>
            <th class="min-w-100px text-end">Actions</th>
          </tr>
        </thead>
        <tbody>
          <!-- Loading State -->
          <tr *ngIf="isLoading">
            <td colspan="10" class="text-center py-5">
              <div class="d-flex justify-content-center align-items-center">
                <span class="spinner-border spinner-border-sm me-2"></span>
                Loading ships...
              </div>
            </td>
          </tr>

          <!-- No Data Row -->
          <tr *ngIf="!isLoading && ships.length === 0">
            <td colspan="10" class="text-center py-5">
              <div class="text-muted">No ships found</div>
            </td>
          </tr>

          <!-- Data Rows -->
          <tr *ngFor="let ship of ships; trackBy: trackByFn">
            <td>
              <div class="d-flex align-items-center">
                <div class="symbol symbol-45px me-5">
                  <div class="symbol-label bg-light-primary">
                    <i class="ki-duotone ki-delivery fs-2 text-primary">
                      <span class="path1"></span>
                      <span class="path2"></span>
                    </i>
                  </div>
                </div>
                <div class="d-flex justify-content-start flex-column">
                  <span class="text-dark fw-bold text-hover-primary fs-6">
                    {{ ship.name || ship.ship_name || '-' }}
                  </span>
                </div>
              </div>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ ship.ship_id || '-' }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ ship.company || '-' }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ ship.voyage_no || '-' }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ ship.sailing_port || '-' }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ ship.destination_port || '-' }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ ship.destination_country || '-' }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ ship.sailing_date | date:'dd/MM/yyyy' }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ ship.arrival_date | date:'dd/MM/yyyy' }}
              </span>
            </td>

            <td class="text-end">
              <div class="d-flex justify-content-end gap-2">
                <!-- Send Mail Icon -->
                <!-- <button type="button" class="btn btn-sm btn-icon btn-light-success"
                  (click)="sendSingleMail(transportPickup)" title="Send Mail">
                  <i class="ki-duotone ki-sms fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button> -->

                <!-- Edit Icon -->
                <button type="button" class="btn btn-sm btn-icon btn-light-primary"
                  (click)="openEditShipModal(ship)" title="Edit Ship">
                  <i class="ki-duotone ki-pencil fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>

                <!-- Delete Icon -->
                <button type="button" class="btn btn-sm btn-icon btn-light-danger"
                  (click)="deleteShip(ship)" title="Delete Ship">
                  <i class="ki-duotone ki-trash fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                    <span class="path4"></span>
                    <span class="path5"></span>
                  </i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <app-pagination *ngIf="!isLoading && ships.length > 0" [paginationInfo]="paginationInfo" [loading]="isLoading"
      (pageChange)="onPageChange($event)">
    </app-pagination>
  </div>
</div>
